import { AppStatus } from '@/redux'
import { APIClient } from '@/services'
import { analytics } from '@/services/analytics/segment'
import { AnyFunction } from '@codeleap/types'
import React from 'react'
import { ModalLessonDone } from '../components/modals'
import { Learn } from '@/features'
import { updateLessonsOpenedCount } from '../utils'
import { isLoggedIn } from '@/features/Auth/session/utils'

export function useLessonCTASideEffects(props: Learn.T.LessonCTAWrapperProps) {
  const { chapter, module, type } = props

  return React.useCallback(
    (callback: AnyFunction) => {
      analytics.track('lesson_complete')
      updateLessonsOpenedCount({ ...chapter, done: true })

      if (isLoggedIn()) {
        APIClient.Learn.chaptersManager.refresh()
        APIClient.Learn.modulesManager.refresh()
      }

      AppStatus.set('splash')
      ModalLessonDone.close()
      callback()
    },
    [chapter, module, type]
  )
}
